export const DEVICE_TRUST_MODES = ['off', 'alert', 'enforce'] as const;
export type DeviceTrustMode = typeof DEVICE_TRUST_MODES[number];

/** Fallback when platform settings omit deviceTrustMode (production). */
export const DEFAULT_DEVICE_TRUST_MODE: DeviceTrustMode = 'enforce';

export interface LoginDeviceRecord {
  deviceId: string;
  label: string;
  platform: string;
  trusted: boolean;
  blocked: boolean;
  hasPasskey?: boolean;
  firstSeenAt: number | null;
  lastSeenAt: number | null;
  lastLoginAt: number | null;
}

export function resolveDefaultDeviceTrustMode(isEmulator: boolean): DeviceTrustMode {
  return isEmulator ? 'alert' : 'enforce';
}

export function normalizeDeviceTrustMode(
  raw: unknown,
  isEmulator = false,
): DeviceTrustMode {
  if (raw === 'off' || raw === 'alert' || raw === 'enforce') return raw;
  return resolveDefaultDeviceTrustMode(isEmulator);
}
